import axiosInstance from "./AxiosInstance";
import config from "../config";

const { apiAppendPath } = config

export const getUserRoles=()=>{
    return axiosInstance.get(`${apiAppendPath.userRoleApiAppendPath}/user-role`)
}